"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bossDump = exports.bossUnpackObject = exports.bossUnpack = exports.bossLoad = void 0;
const unicrypto_1 = require("unicrypto");
/**
 * Unpack boss object from the base64 encoded string or binary array.
 * @param data to unpack
 */
function bossLoad(data) {
    const src = data instanceof Uint8Array ? data : unicrypto_1.decode64(data);
    return (unicrypto_1.Boss.load(src));
}
exports.bossLoad = bossLoad;
/**
 * Strongly typed Boss Unpack, recommended boss object from the base64 encoded string or binary array.
 * @param data to unpack
 */
function bossUnpack(data) {
    const src = data instanceof Uint8Array ? data : unicrypto_1.decode64(data);
    return (unicrypto_1.Boss.load(src));
}
exports.bossUnpack = bossUnpack;
function bossUnpackObject(data) {
    return bossUnpack(data);
}
exports.bossUnpackObject = bossUnpackObject;
/**
 * Pack any source object to boss binary binary notation
 * @param data
 */
function bossDump(data) {
    return unicrypto_1.Boss.dump(data);
}
exports.bossDump = bossDump;
//# sourceMappingURL=SimpleBoss.js.map